import { Input } from "./ui/input";
import { Button } from "./ui/button";

export const FormField = ({ label, ...props }) => (
  <div className="flex flex-col gap-2">
    <span className="label-tech">{label}</span>
    <Input className="bg-[#0A0A0A] border-[#262626] rounded-sm h-11" {...props} />
  </div>
);

export const PrimaryButton = ({ children, ...props }) => (
  <Button
    className="h-11 rounded-sm bg-[#007AFF] hover:bg-[#0062cc] text-white font-semibold uppercase tracking-widest text-xs active:scale-[0.98] transition-transform"
    {...props}
  >
    {children}
  </Button>
);

export const SecondaryButton = ({ children, ...props }) => (
  <Button
    variant="outline"
    className="h-11 rounded-sm border-[#262626] bg-transparent hover:bg-[#1F1F1F] uppercase tracking-widest text-xs"
    {...props}
  >
    {children}
  </Button>
);
